import PropTypes from 'prop-types';
import { Avatar as AntAvatar } from 'antd';
import { useAuthStore } from '@stores/auth.store';
import { hashStringToHsl } from '@utils/colors';

/**
 * Global avatar:
 * - tenant-wide preference: user.preferences.avatarMode ('theme'|'random'|'custom')
 * - tenant-wide preference: user.preferences.avatarColor (hex) for custom mode
 */
export default function AppAvatar({
    src,
    alt,
    name,
    seed,
    size,
    style,
    ...props
}) {
    const prefs = useAuthStore((s) => s.user?.preferences) || {};
    const mode = prefs?.avatarMode || 'theme';
    const custom = prefs?.avatarColor || null;
    const themePrimary = useAuthStore((s) => s.user?.preferences?.primaryColor) || null;

    const effectiveSeed = seed || name || alt || 'user';
    const backgroundColor =
        mode === 'custom' && custom
            ? custom
            : mode === 'random'
                ? hashStringToHsl(effectiveSeed)
                : themePrimary || '#F04A4A';

    const initial = (name || alt || 'U').trim()?.[0]?.toUpperCase?.() || 'U';

    return (
        <AntAvatar
            src={src || undefined}
            alt={alt}
            size={size}
            style={{
                backgroundColor,
                flexShrink: 0,
                ...(style || {}),
            }}
            {...props}
        >
            {initial}
        </AntAvatar>
    );
}

AppAvatar.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    name: PropTypes.string,
    seed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    style: PropTypes.object,
};

